<button
  *tuiLet="isTop$ | async as top"
  (click)="scroll$.next(top ? 'bottom' : 'top')"
  appearance="accent"
  tuiIconButton
  size="m"
  [icon]="top ? 'tuiIconArrowDown' : 'tuiIconArrowUp'"
></button>
